import tips from './tips'
import copay from './copay'
import delivery from './delivery'

export default {
  'approve-type': {
    'face-2-face-id-required': {
      label: 'Требуется личное предъявление ID и подписи',
      description_1: 'Рецепт будет доставлен только назначенному пациенту. Требуются как удостоверение личности, так и подпись получателя, '
        + 'при этом удостоверение должно соответствовать имени получателя.',
      description_2: 'Водитель сфотографирует удостоверение личности пациента и дверь при доставке.',
    },
    'face-2-face-not-required': {
      label: 'Подпись при личной встрече не требуется',
      description: 'Подпись требуется от любого взрослого (18+), проживающего вместе с пациентом. Водитель сделает фотографию двери пациента.',
    },
    'face-2-face-required': {
      label: 'Требуется подпись при личной встрече',
      description: 'Подпись требуется от любого человека, проживающего вместе с пациентом. Водитель сделает фотографию двери пациента.',
    },
    'non-contract-delivery': {
      label: 'Бесконтактная доставка',
      description: 'Водитель оставит посылку у двери и сделает фотографию, не пытаясь доставить лично.',
    },
    'online-signature': {
      label: 'Онлайн-подпись',
      description_1: 'Водитель оставит рецепт у двери и сделает фотографию, только',
      description_2: 'если получатель подпишется онлайн до доставки. Без онлайн-подписи способ доставки',
      description_3: 'будет осуществлен как «Требуется подпись при личной встрече».',
    },
    'signature-optional': {
      label: 'Подпись не обязательна',
      description: 'Водитель попытается доставить лично. Если никого нет дома, водитель оставит посылку у двери и сделает фотографию.',
    },
  },
  tips,
  copay,
  delivery,
  wait: 'Пожалуйста, подождите...',
  'promised-eta': 'Ожидаемое время прибытия:',
  reschedule: 'Перенести / Изменить адрес',
  dates: {
    today: 'Сегодня',
    tomorrow: 'Завтра',
    'today-at': 'Сегодня в {time}',
    'date-at': '{date} в {time}',
    'before-time': 'до {time}',
    'time-until': '{from} - {time}',
    'time-from': '{time} - {to}',
    apt: 'кв.',
    'delivery-unavailable': 'Дата доставки недоступна',
  },
  payment: {
    error: 'Ошибка',
    success: 'Успешно',
    'transaction-error': 'Ошибка транзакции: {message}',
    okay: 'Хорошо',
    'copay-success': 'Доплата прошла успешно',
    'success-bang': 'Успешно!',
  },
  role: {
    driver: 'Водитель',
    dispatcher: 'Диспетчер',
  },
  'address-check': {
    title: 'Адрес изменён',
    entered: 'Введённый адрес:',
    validated: 'Проверенный адрес:',
    accept: 'ПРИНЯТЬ ИЗМЕНЕНИЯ',
    keep: 'Мой адрес верный',
    cancel: 'Отмена',
  },
  push: {
    title: 'Включить push-уведомления',
    message: 'Получайте мгновенные обновления статуса доставки через уведомления браузера.',
  },
}
